import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { PopoverComponent } from "./popover.component";
import { MatIconModule } from "@angular/material/icon";
import { PopoverLoaderModule } from "../../../common/popover-loader/popover-loader.module";

@NgModule({
  declarations: [
    PopoverComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    PopoverLoaderModule
  ],
  exports: [PopoverComponent]
})
export class PopoverModule { }